import {
  GetTicketSalesResponse,
  GetTicketCancellationsResponse,
} from '../types/ticketStats';
import apiAxios from './apiAxios';
import { handleResponse } from './handleResponse';

const BASE_COMPANY_ROUTE = '/api/companies';

export const ticketStatsApi = {
  getTicketSales: (
    companyId: string,
    params: { startDate: string; endDate: string }
  ) =>
    apiAxios
      .get<GetTicketSalesResponse[]>(
        `${BASE_COMPANY_ROUTE}/${companyId}/analytics/tickets/sales`,
        { params }
      )
      .then(handleResponse),
  getTicketCancellations: (
    companyId: string,
    params: { startDate: string; endDate: string }
  ) =>
    apiAxios
      .get<GetTicketCancellationsResponse[]>(
        `${BASE_COMPANY_ROUTE}/${companyId}/analytics/tickets/cancellations`,
        { params }
      )
      .then(handleResponse),
  areTicketsAvailable: (companyId: string) =>
    apiAxios
      .get<{
        hasTickets: boolean;
      }>(`/api/portal/company/${companyId}/tickets/available`)
      .then(handleResponse),
};
